import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> "Retinal Embossing" </h1>

    
    <div className="imgs max800">
        <div>
            <img 
                src={require('../assets/painting/retina_v2.jpg')} 
                data-skip-gallery
                />
            <p>Oil and acrylic, 1.5' x 1.5'</p>
        </div>
    </div>

    <h2>Concept:</h2>
    An individual with Crystalline Retinopathy can exhibit "deposits" on the retina of their eye, which to me actually look like beautiful gold embossing. I mimicked 
    the looks of this based on the below images and made a painting with oil paint for the retina and gold acrylic to mimic these embossing-like deposits.
    <div className="imgs max800">
        <div>
            <img 
                src={require('../assets/painting/retinaDemo2.jpg')} 
                data-skip-gallery
                />
            <p>Imaging of retina</p>
        </div>
        <div>
            <img 
                src={require('../assets/painting/retinaDemo.jpg')} 
                data-skip-gallery
                />
            <p>Example of the deposits on retina</p>
        </div>
    </div>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.